export function processItemsHover() {
    $('.process-item a').hover(function () {
        $(this).closest('li').addClass('hovered');
    }, function () {
        $(this).closest('li').removeClass('hovered');
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/processItemsHover.js